import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptSpeakerMergeFailedAction = {
	type: 'TRANSCRIPT_SPEAKER_MERGE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptSpeakerMergeFailedAction => ({
	type: 'TRANSCRIPT_SPEAKER_MERGE_FAILED',
	payload,
});
